import CONSTANTS from "shared/constants";
import axios from "axios";

export default class ApiMethods {
  static async apiRequest(
    method,
    url,
    data = {},
    params = {},
    withCredentials = true,
  ) {
    try {
      const res = await axios.request({
        method: method,
        url: url,
        data: data,
        params: params,
        withCredentials: withCredentials,
      });
      return res.data;
    } catch (error) {
      return {
        response: {
          code:
            error.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
              ? CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
              : -1,
        },
      };
    }
  }

  static get(url, params = {}, withCredentials = true) {
    return this.apiRequest("GET", url, null, params, withCredentials);
  }

  static post(url, data = {}, withCredentials = true) {
    return this.apiRequest("POST", url, { data: data }, null, withCredentials);
  }

  static put(url, data = {}, withCredentials = true) {
    return this.apiRequest("PUT", url, { data: data }, null, withCredentials);
  }

  static delete(url, withCredentials = true) {
    return this.apiRequest("PUT", url, null, null, withCredentials);
  }
}
